import React from "react";
import DeclarationLayout, { Point } from "./DeclarationLayout";

// Individual member declaration & terms (opened from the Individual membership
// form). Content mirrors the "Individual Member Declaration" document.
export default function IndividualDeclaration() {
  return (
    <DeclarationLayout
      title="घोषणा-पत्र एवं नियम एवं शर्तें"
      subtitle="National Skill & Vocational Education Council (NSVEC), New Delhi"
      crumbLabel="Individual Member Declaration"
    >
      <div className="decl-intro">
        मैं, नीचे हस्ताक्षरकर्ता, यह घोषणा करता/करती हूँ कि Membership हेतु मेरे द्वारा
        प्रस्तुत की गई समस्त जानकारी, विवरण एवं दस्तावेज मेरी जानकारी एवं विश्वास के
        अनुसार सत्य, सही एवं पूर्ण हैं। मैं National Skill &amp; Vocational Education
        Council (NSVEC) की Membership से संबंधित निम्नलिखित घोषणा एवं नियम एवं शर्तों को
        स्वीकार करता/करती हूँ:
      </div>

      <Point
        heading="1. सदस्य की सही जानकारी"
        hi="मैंने Membership Application में अपना नाम, Registration/Membership Number, Course/Programme तथा अन्य आवश्यक विवरण सही एवं पूर्ण रूप से उपलब्ध कराया है। भविष्य में किसी जानकारी में परिवर्तन होने पर Council को सूचित करना मेरी जिम्मेदारी होगी।"
      />
      <Point
        heading="2. जानकारी की सत्यता"
        hi="मैं घोषणा करता/करती हूँ कि मेरे द्वारा आवेदन में दी गई सभी जानकारी सत्य एवं सही है। किसी भी तथ्य को जानबूझकर छिपाना, गलत जानकारी देना अथवा भ्रामक विवरण प्रस्तुत करना Membership के विरुद्ध माना जाएगा।"
      />
      <Point
        heading="3. दस्तावेजों की जिम्मेदारी"
        hi="मेरे द्वारा प्रस्तुत सभी प्रमाण-पत्र, दस्तावेज एवं अभिलेख वास्तविक एवं वैध होने चाहिए। यदि किसी दस्तावेज के फर्जी, जाली, गलत अथवा भ्रामक पाए जाने की स्थिति में Council को लागू नियमों के अनुसार मेरी Membership को निलंबित अथवा निरस्त करने का अधिकार होगा।"
      />
      <Point
        heading="4. NSVEC के नियमों की स्वीकृति"
        hi="मैं NSVEC द्वारा समय-समय पर निर्धारित नियमों, policies, guidelines, code of conduct तथा Membership से संबंधित अन्य शर्तों का पालन करने के लिए सहमत हूँ। नियमों का उल्लंघन Membership के विरुद्ध कार्रवाई का आधार हो सकता है।"
      />
      <Point
        heading="5. Membership का दायरा"
        hi="मैं समझता/समझती हूँ कि NSVEC Membership का अर्थ Council द्वारा प्रदान की गई निर्धारित Membership/Status है। Membership को अपने-आप में सरकारी नौकरी, सरकारी नियुक्ति, सरकारी लाइसेंस, सरकारी मान्यता अथवा किसी statutory qualification के रूप में प्रस्तुत नहीं किया जाएगा, जब तक उसके लिए संबंधित सक्षम प्राधिकारी द्वारा पृथक एवं वैध प्राधिकरण उपलब्ध न हो।"
      />
      <Point
        heading="6. NSVEC के नाम एवं Logo का उपयोग"
        hi="NSVEC का नाम, Logo, Certificate, Membership Number, Identity Card अथवा अन्य आधिकारिक पहचान/सामग्री का उपयोग केवल Council द्वारा निर्धारित नियमों एवं अधिकृत उद्देश्य के लिए किया जाएगा। Member किसी भी प्रकार से Council की ओर से अनधिकृत प्रतिनिधित्व या दावा नहीं करेगा।"
      />
      <Point
        heading="7. Membership का निलंबन अथवा निरस्तीकरण"
        hi="गलत या फर्जी जानकारी, दस्तावेजों में अनियमितता, misconduct, नियमों का उल्लंघन, NSVEC के नाम/Logo का अनधिकृत उपयोग अथवा Council की प्रतिष्ठा को प्रभावित करने वाले किसी अनुचित आचरण की स्थिति में Council को लागू नियमों एवं निर्धारित प्रक्रिया के अनुसार Membership को निलंबित अथवा निरस्त करने का अधिकार होगा।"
      />
      <Point
        heading="8. दस्तावेज एवं जानकारी का सत्यापन"
        hi="मैं NSVEC को मेरे द्वारा प्रस्तुत जानकारी, प्रमाण-पत्र एवं दस्तावेजों के सत्यापन की अनुमति देता/देती हूँ। आवश्यकता पड़ने पर Council संबंधित संस्था/प्रशिक्षण केंद्र/परीक्षण या प्रमाणन निकाय से जानकारी की पुष्टि कर सकती है।"
      />
      <Point
        heading="9. Fee एवं Refund Policy"
        hi="Application Fee, Membership Fee, Renewal Fee अथवा अन्य निर्धारित शुल्क Council की लागू Fee एवं Refund Policy के अधीन होंगे। शुल्क के भुगतान के बाद Refund केवल Council की निर्धारित नीति एवं लागू नियमों के अनुसार ही किया जाएगा।"
      />
      <Point
        heading="10. विवाद एवं क्षेत्राधिकार"
        hi="Membership से संबंधित किसी विवाद, शिकायत अथवा मतभेद की स्थिति में पहले Council की निर्धारित grievance/dispute resolution प्रक्रिया का पालन किया जाएगा। किसी विवाद के न्यायिक निस्तारण की आवश्यकता होने पर लागू कानून एवं सक्षम न्यायालय के क्षेत्राधिकार के अनुसार कार्रवाई की जाएगी।"
      />

      <div className="decl-final">
        <h3>सदस्य की घोषणा</h3>
        <p>
          मैंने उपरोक्त घोषणा-पत्र एवं नियम एवं शर्तों को ध्यानपूर्वक पढ़ लिया है। मैं
          इसकी सभी शर्तों को समझता/समझती हूँ और स्वेच्छा से स्वीकार करता/करती हूँ। मेरे
          द्वारा दी गई जानकारी एवं दस्तावेजों की सत्यता की पूर्ण जिम्मेदारी मेरी होगी।
        </p>
      </div>
    </DeclarationLayout>
  );
}
